import { useEffect, useState } from "react";

const DURATION_MS = 48 * 60 * 60 * 1000;

const pad = (n) => String(n).padStart(2, "0");

export const AnnouncementBar = () => {
  const [target] = useState(() => Date.now() + DURATION_MS);
  const [left, setLeft] = useState(DURATION_MS);

  useEffect(() => {
    const tick = () => setLeft(Math.max(0, target - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  const hours = Math.floor(left / 3600000);
  const minutes = Math.floor((left % 3600000) / 60000);
  const seconds = Math.floor((left % 60000) / 1000);

  return (
    <div
      data-testid="announcement-bar"
      className="bg-[#C6FF3D] text-black text-xs sm:text-sm font-semibold py-2 px-4 flex items-center justify-center gap-2 sm:gap-3 text-center"
    >
      <span className="truncate">LAUNCH OFFER: 7 DAYS FREE + 50% OFF FIRST MONTH</span>
      <span
        data-testid="announcement-countdown"
        className="font-display bg-black text-[#C6FF3D] px-2 py-0.5 rounded-md tracking-wide flex-shrink-0"
      >
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>
    </div>
  );
};
